import React, { ChangeEvent, FC, useEffect, useRef, useState } from "react"

import { KButton, KDropdown, KSpan } from "kahuna-base-react-components"
import { TrackRegistryConsentFile, User } from "../../../types"
//@ts-ignore
import ErrorIcon from "../../../assets/release-registry-icons/close-circle-red.svg"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { handleAuthorizedRequest, users } from "../../../apis"

interface SearchUserComponentProps {
  className: string
  selectedUser: KSelectOption | undefined
  setSelectedUser: (selectedUser: KSelectOption | undefined) => void
}

const SearchUserComponent: FC<SearchUserComponentProps> = (props) => {
  const { className, selectedUser, setSelectedUser } = props

  const [searchUser, setSearchUser] = useState<boolean>(false)
  const [userOptions, setUserOptions] = useState<KSelectOption[]>([])
  const [userLoading, setUserLoading] = useState(false)
  const [timeoutId, setTimeoutId] = useState(null)

  const onSearchTextChanged = async (text: string) => {
    if (!text) return
    setUserOptions([])
    setUserLoading(true)
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    setTimeoutId(
      //@ts-ignore
      setTimeout(async () => {
        await handleAuthorizedRequest(async () => {
          const response = await users(`/?limit=10&offset=0&username=${text}`, "get")
          setUserOptions(
            response.data.results.map((user: User) => ({
              value: user.id,
              label: user.username
            }))
          )
          setUserLoading(false)
        }, "")
      }, 500)
    )
  }

  return (
    <div className={className}>
      <div className="relative">
        {searchUser ? (
          <div
            onKeyDown={(event) => {
              if (event.key === "Escape") {
                setSearchUser(false)
              }
            }}
          >
            <KDropdown
              dataTestId={"search-user-filter"}
              placeholder={"Search user to filter"}
              padding="8px"
              width={240}
              disableFilterOption={true}
              selected={selectedUser}
              onInputChange={onSearchTextChanged}
              options={userOptions}
              isClearable={true}
              onSelect={(selectedOption) => {
                const selected = selectedOption as KSelectOption
                setSelectedUser(selected)
              }}
            />
          </div>
        ) : (
          <div>
            <KButton
              dataTestId="search-user-button"
              leftIcon="/reports_icons/user.svg"
              gap="4px"
              text="Search user"
              height="36px"
              width="auto"
              background="#F7F7F7"
              hoverBackground="#F3F3F3"
              activeBackground="#F7F7F7"
              padding="8px"
              shadowDisabled
              onClick={() => {
                setSearchUser(true)
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchUserComponent
